import { ApiConfig } from './IConfig';
import envConfig from './envConfig';
/**
 * api endpoint configurations.
 *
 * method: method of crud operations
 * endpoint: endpoint of api
 * data: payload data needs to pass with api
 * baseUrl: specific base url for the api
 * tokenId: if any specific token pass with headers
 * mode: request mode
 * header: additional headers
 * export {
 *   apiConfig
 * }
 */
const apiConfig: { [key: string]: ApiConfig } = {
  search: {
    method: 'POST',
    endpoint: '/v1.0/Search',
    headers: {
      authorization: 'Bearer $accessToken'
    },
    scopes: [envConfig.customApi.apiScope],
    data: {
      Query: '',
      Size: '',
      ReturnFields: [],
      verticals: "",
      FederatorMetadata: true,
      HitHighlightedProperties: true
    }
  },
   HybridSearch: {
    method: 'POST',
    endpoint: '/v1/HybridSearch',
    headers: {
      authorization: 'Bearer $accessToken'
    },
    scopes: [envConfig.customApi.apiScope],
    data: {
      Query: '',
      Size: '',
      ReturnFields: [],
      verticals: "",
      FederatorMetadata: true,
      HitHighlightedProperties: true
    }
  },
  getUserProfileProperties: {
    method: 'GET',
    endpoint: '/v1.0/UserPreferences',
    headers: {
      authorization: 'Bearer $accessToken'
    },
    scopes: [envConfig.customApi.apiScope]
  },
  setUserProfileProperties: {
    method: 'POST',
    endpoint: '/v1.0/RecentSearches',
    headers: {
      authorization: 'Bearer $accessToken'
    },
    scopes: [envConfig.customApi.apiScope],
    data: {}
  },
  setRecentItemClick: {
    method: 'POST',
    endpoint: '/v1.0/RecentClickedItems',
    headers: {
      authorization: 'Bearer $accessToken'
    },
    scopes: [envConfig.customApi.apiScope],
    data: {}
  },
  removeRecentSearchValues: {
    method: 'DELETE',
      endpoint: '/v1.0/DeleteRecentSearchItems',
    headers: {
      authorization: 'Bearer $accessToken'
    },
    scopes: [envConfig.customApi.apiScope],
    data: {}
  },
  analytics: {
    method: 'POST',
    scopes: [envConfig.customApi.apiScope],
    endpoint: '/v1.0/Analytics',
    headers: {
      authorization: 'Bearer $accessToken'
    }
  },
  getProfilePicture: {
    method: 'POST',
    baseUrl: 'https://graph.microsoft.com',
    endpoint: '/v1.0/$batch',
    headers: {
      'Content-Type': 'application/json',
      authorization: 'Bearer $accessToken'
    }
  },
  querySuggestions: {
    method: 'POST',
    endpoint: '/v1/QueryRecommendations',
    headers: {
      authorization: 'Bearer $accessToken'
    },
    scopes: [envConfig.customApi.apiScope],
    data: {
      Size: 8,
      Query: ''
    }
  },
  getUserExtensionProperties: {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: 'Bearer $accessToken'
    },
    baseUrl: 'https://graph.microsoft.com',
    endpoint: '/v1.0/me?'
  },

  getOntologyData: {
    method: 'POST',
    baseUrl: '',//base url is added through fetchOntologyData method
    endpoint: '/api/poolparty/v2/search',
    scopes: [envConfig.customApi.apiScope],
    headers: {
     'Content-Type': 'application/json',
      authorization: 'Bearer $accessToken'
    },
    data: {
      searchText:'',
      filterBy: envConfig.ontology.limitBy
    }
  },
  getBrowseConfiguration: {
    method: 'GET',
    endpoint: '/BrowseConfig',
    headers: {
      authorization: 'Bearer $accessToken'
    },
    scopes: [envConfig.customApi.apiScope]
  },
  insightsfeedback: {
      method: 'POST',
      endpoint: '/v1.0/InsightsFeedback',
      headers: {
        authorization: 'Bearer $accessToken'
      },
      scopes: [envConfig.customApi.apiScope]
  },
  toggleAISearch: {
    method: 'POST',
    endpoint: '/v1.0/ToggleAISearch',
    headers: {
      authorization: 'Bearer $accessToken'
    },
    scopes: [envConfig.customApi.apiScope],
    data: {}
  }
};
export { apiConfig };

